import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { FlexColumn } from '../../../components/atoms/layout/Flex'
import { CompanySelectors } from '../../../store/company/selectors'
import VisitorRegistrationClientTable from '../../../components/organisms/visitor/registration/ClientTable'
import { CompanyActions } from '../../../store/company'

export default function VisitorRegistrationPage() {
  const dispatch = useDispatch()
  const clients = useSelector(CompanySelectors.clients)
  const recordSet = useSelector(CompanySelectors.visitorRegistrationRecordSet)

  useEffect(() => {
    dispatch(CompanyActions.fetchVisitorRegistrationRecords())
  }, [dispatch])

  return (
    <FlexColumn>
      <VisitorRegistrationClientTable
        clients={clients}
        submittedRecords={recordSet.submittedRecords}
        receivedRecords={recordSet.receivedRecords}
      />
    </FlexColumn>
  )
}
